import "bootstrap/dist/css/bootstrap.min.css";
import { useNavigate } from "react-router-dom";
import "datatables.net";
import "datatables.net-buttons";
import "datatables.net-buttons-dt/css/buttons.dataTables.min.css";
import "datatables.net-buttons/js/buttons.colVis";
import "datatables.net-buttons/js/buttons.html5";
import "datatables.net-buttons/js/buttons.print";
import $ from "jquery";
import React, { useEffect, useRef, useState } from "react";
import { baseurl } from "../utility/helper";
import Swal from "sweetalert2";

const TransactionList = () => {
  const roleid = parseInt(sessionStorage.getItem("userroleId"));
  const [TransactionList, setTransactionList] = useState([]);
  const [transactionType, setTransactionType] = useState([]); //  store from DB
  const [transactionTypes, setTransactionTypes] = useState([]); //  store from DB
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [chapters, setChapters] = useState([]);
  const [chapterId, setChapterId] = useState(
    roleid === 2 ? sessionStorage.getItem("userchapterId") || "" : ""
  );

  const tableRef = useRef(null);

    // Fetch transaction types from DB
  const fetchTransactionTypes = async () => {
    try {
      const token = sessionStorage.getItem("token");
      const response = await fetch(`${baseurl}/admin/TransactionTypes`, {
        method: "GET",
        headers: {
          Authorization: `${token}`,
          "Content-Type": "application/json",
        },
      });

      if (!response.ok) throw new Error("Failed to fetch transaction types");

      const data = await response.json();
      setTransactionTypes(data);
    } catch (error) {
      console.error("Error fetching transaction types:", error);
    }
  };

  const fetchChapters = async (type = "active") => {
    try {
      const token = sessionStorage.getItem("token");

      let url = `${baseurl}/admin/chapters`;
      if (type) {
        url += `?type=${type}`; 
      }

      const res = await fetch(url, {
        headers: {
          Authorization: token,
        },
      });

      const data = await res.json();
      setChapters(data);
    } catch (err) {
      console.error("Error fetching chapters:", err);
    }
  };

  const fetchTransactionList = async () => {
    try {
      const token = sessionStorage.getItem("token");
      let url = `${baseurl}/admin/TransactionList`;

      let queryParams = [];

      if (chapterId) {
        queryParams.push(`chapter_id=${chapterId}`);
      }

      // If not super admin, filter by chapter_id
      if (roleid !== 1) {
        queryParams.push(`chapter_id=${chapterId}`);
      }

      // Apply filters if selected
      if (transactionType) queryParams.push(`type=${transactionType}`);
      if (startDate) queryParams.push(`start_date=${startDate}`);
      if (endDate) queryParams.push(`end_date=${endDate}`);

      if (queryParams.length > 0) {
        url += "?" + queryParams.join("&");
      }

      const response = await fetch(url, {
        method: "GET",
        headers: {
          Authorization: `${token}`,
          "Content-Type": "application/json",
        },
      });

      if (!response.ok) {
        throw new Error("Network response was not ok");
      }

      const data = await response.json();
      setTransactionList(data);
    } catch (error) {
      console.error("Error fetching TransactionList:", error);
    }
  };

  useEffect(() => {
    fetchTransactionTypes(); // load types on page load
    fetchChapters();
    fetchTransactionList();
  }, []);

  useEffect(() => {
    const tableElement = tableRef.current;

    if (tableElement) {
      if ($.fn.DataTable.isDataTable(tableElement)) {
        $(tableElement).DataTable().destroy();
      }

      $(tableElement).DataTable({
        dom: "Blfrtip",
        pageLength: 25,
        lengthMenu: [[10, 25, 50, 100, 250, 500, -1], [10, 25, 50, 100, 250, 500, "All"]],
        buttons: [
          { extend: "copyHtml5", className: "btn btn-primary dttable", exportOptions: { columns: ":visible" } },
          { extend: "excelHtml5", className: "btn btn-primary dttable", exportOptions: { columns: ":visible" } },
          { extend: "csvHtml5", className: "btn btn-primary dttable", exportOptions: { columns: ":visible" } },
          { extend: "pdfHtml5", className: "btn btn-primary dttable", exportOptions: { columns: ":visible" } },
          { extend: "print", className: "btn btn-primary dttable", exportOptions: { columns: ":visible" } },
        ],
        data: TransactionList,
        columns: [
          { data: null, title: "Sr.No", className: "text-center" },
          { data: null, title: "Membership No", className: "text-center" },
          { data: null, title: "Candidate No", className: "text-center" },
          { data: "chapter_id", title: "Chapter ID", className: "text-center" },
          { data: null, title: "Name", className: "text-center" },
          { data: "mobile_no", title: "Mobile No", className: "text-center" },
          { data: "email", title: "Email", className: "text-center" },
          { data: "transaction_type", title: "Transaction Type", className: "text-center" },
          { data: "amount", title: "Transaction Amount", className: "text-center" },
          { data: "trans_datetime", title: "Transaction Date", className: "text-center" },
          { data: "payment_method", title: "Method", className: "text-center" },
          { data: "payment_no", title: "Transaction Number", className: "text-center" },
          { data: "payment_status", title: "Payment Status", className: "text-center" },
        ],
        columnDefs: [
          {
            targets: 0,
            render: (data, type, row, meta) => meta.row + 1,
          },
          // ── Membership No → navigate to MemberForm ────────────────────────────
          {
              targets: 1,
              render: (data, type, row) => {
                  const membershipNo = row.membership_no;
                  const memberId = row.member_id;

                  if (type !== "display") {
                      return membershipNo || "";
                  }

                  if (!membershipNo) {
                      return `<span class="cl-muted">—</span>`;
                  }

                  const url = `/admin/EditMember?memberId=${memberId}&edit=true`;

                  return `
                      <a
                          href="${url}"
                          class="cl-id-link"
                          onclick="event.preventDefault(); window.open(this.href, '_blank');"
                          style="font-family:monospace;letter-spacing:0.04em"
                      >
                          ${membershipNo}
                      </a>
                  `;
              },
          },

          // ── Candidate No → CandiAdd in new tab ────────────────────────
          {
              targets: 2,
              render: (data, type, row) => {
                  const candidateId = row.candidate_id;

                  if (type !== "display") {
                      return candidateId || "";
                  }

                  if (!candidateId) {
                      return `<span class="cl-muted">—</span>`;
                  }

                  const url = `/admin/CandiAdd/${candidateId}`;

                  return `
                      <a
                          href="${url}"
                          class="cl-id-link"
                          onclick="event.preventDefault(); window.open(this.href, '_blank');"
                      >
                          ${candidateId}
                      </a>
                  `;
              },
          },
          {
            targets:   4,     
            render: (data, type, row, meta) => `${row.first_name || ''} ${row.last_name || ''}`
          },
          {
            targets: 9,
            render: (data, type, row, meta) => {
              if (!data) return type === "display" ? "-" : 0;
              const date = new Date(data);
              // For sort/type/filter, return a value that sorts correctly
              if (type !== "display") {
                return date.getTime(); // numeric timestamp sorts chronologically
              }
              // Display formatting stays DD-MM-YYYY in IST
              const parts = new Intl.DateTimeFormat('en-GB', {
                timeZone: 'Asia/Kolkata',
                day: '2-digit',
                month: '2-digit',
                year: 'numeric'
              }).formatToParts(date);
              const day = parts.find(p => p.type === 'day').value;
              const month = parts.find(p => p.type === 'month').value;
              const year = parts.find(p => p.type === 'year').value;
              return `${day}-${month}-${year}`;
            },
          },
        ],
        initComplete: function () {
          $('.dt-length select').addClass('form-select form-select-sm');
        }
        
      });

      return () => {
        if ($.fn.DataTable.isDataTable(tableElement)) {
          $(tableElement).DataTable().destroy();
        }
      };
    }
  }, [TransactionList]);

  // ── Apply Filters: show a "please wait" modal for the duration of the
  //    fetch, and close it once the new data has landed. The table effect
  //    above (keyed on TransactionList) then rebuilds the DataTable on its own.
  const handleApplyFilters = async () => {
    Swal.fire({
      title: 'Please wait...',
      text: 'Filtering transactions',
      allowOutsideClick: false,
      allowEscapeKey: false,
      showConfirmButton: false,
      didOpen: () => Swal.showLoading()
    });

    try {
      await fetchTransactionList();
    } finally {
      Swal.close();
    }
  };

  return (
    <div className="content container-fluid">
      <center>
        <h1>Transaction List</h1>
      </center>
      <br />
      {/* 🔹 Filters */}
      <div className="card p-3 mb-3">
        <div className="row g-3 align-items-center">
          <div className="col-md-3">
            <label className="form-label">Chapter</label>
            <select
              className="form-select"
              value={chapterId}
              onChange={(e) => setChapterId(e.target.value)}
              disabled={roleid !== 1} // only admin can change
            >
              <option value="">All</option>
              {chapters.map((ch) => (
                <option key={ch.chapter_id} value={ch.chapter_id}>
                  {ch.chapter_name}
                </option>
              ))}
            </select>
          </div>
          <div className="col-md-3">
            <label className="form-label">Transaction Type</label>
            <select
              className="form-select"
              value={transactionType}
              onChange={(e) => setTransactionType(e.target.value)}
            >
              <option value="">All</option>
              {transactionTypes.map((type) => (
                <option key={type.trans_type_id} value={type.trans_type_id}>
                  {type.transaction_type}
                </option>
              ))}
            </select>
          </div>

          <div className="col-md-3">
            <label className="form-label">Start Date</label>
            <input
              type="date"
              className="form-control"
              value={startDate}
              onChange={(e) => setStartDate(e.target.value)}
            />
          </div>

          <div className="col-md-3">
            <label className="form-label">End Date</label>
            <input
              type="date"
              className="form-control"
              value={endDate}
              onChange={(e) => setEndDate(e.target.value)}
            />
          </div>

          <div className="col-md-3 d-flex align-items-end">
            <button
              className="btn btn-success w-100"
              onClick={handleApplyFilters}
            >
              Apply Filters
            </button>
          </div>
        </div>
      </div>

      {/* 🔹 DataTable */}
      <div className="content container-fluid">
        <div className="profile-section">
            <div className="list" style={{ overflow: "auto" }}>
            <div className="row">
              <div className="col-12">
                <table
                  ref={tableRef}
                  className="table table-striped table-bordered"
                  style={{ width: "100%" }}
                ></table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TransactionList;